const notEmptyStringOrArray = (value) => {
  return value?.length > 0
}

export default notEmptyStringOrArray
